import { useSelector } from 'react-redux';

export const useCurrentOrderCartItems = () => {
  const {
    additionalData: { selectedStudent },
    v3Order: { orders },
    shoot: { shoot: shootInfo },
  } = useSelector((state) => state);

  const shootEventId = shootInfo?.event_id || shootInfo?.id;
  const orderKey =
    shootEventId && selectedStudent?.id
      ? `${shootEventId}-${selectedStudent.id}`
      : null;
  const order = orderKey ? orders[orderKey] : null;
  return order ? order.cartItems : [];
};
